import '@opten/gin-tonic/components/image';
import { factory } from '@opten/gin-tonic/helpers/compiler';

//INSERT GIN TONIC COMPS HERE
import { MagicScrollToggleVisibilityComponent } from '../libs/gin-tonic/components/scroll-magic/toggle-visibility';
import { CollapseComponent } from '../libs/gin-tonic/components/collapse/component';
import { FormFieldComponent } from '../libs/gin-tonic/components/form-field/component';
import { DialogComponent } from '../libs/gin-tonic/components/dialog/component';

import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.scss';

import components from './components/index';
import { createDefaultComponent } from '../libs/gin-tonic/helpers/components/index';
import { Clickable } from '../libs/gin-tonic/components/clickable/index';

const bsComponents = [
	CollapseComponent,
	MagicScrollToggleVisibilityComponent,
	FormFieldComponent,
	DialogComponent,
	createDefaultComponent(Clickable, 'js-clickable')
];
const allComponents = [...bsComponents, ...components];

AOS.init({
	offset: 200
});

factory(allComponents)(document.body);
